<template lang="pug">
  div.centralized.rounded-container
    .row
      el-button(@click="openModal('add')", class="add-button")
        span Adicionar UPFPA
    h2(style="border-bottom: 1px solid #ccc; padding-bottom: 10px;") UPF por Ano

    el-table(:data="upf", style="width: 200%")
      el-table-column(label="Ano", width="auto", prop="ano")
      el-table-column(label="Ajuste Monetário (UPFPA)", width="auto", prop="valor")
      el-table-column(label="ifd 1", prop="ifd1", sortable)
      el-table-column(label="ifd 2", prop="ifd2", min-width="100", sortable)
      el-table-column(label="Taxa Juros PF", prop="taxaJuros", min-width="100", sortable)
      el-table-column(label="Taxa Juros PJ", prop="taxaJurosPj", min-width="100", sortable)
      el-table-column(label="Ações")
        template(slot-scope="scope")
          el-dropdown(trigger="click" , size="small")
            el-button(type="primary", class="el-dropdown-link" , size="mini")
              span Ações
              i.el-icon-arrow-down.el-icon--right

            el-dropdown-menu(:style="{ cursor: isCurrentYear(scope.row.ano) ? 'not-allowed' : 'pointer' }")
             el-dropdown-item(:disabled="isCurrentYear(scope.row.ano)")
              span(@click="editUpf(scope.row)")
                i.el-icon-edit
                span Editar
    el-dialog(:visible.sync="isModalOpen", :close-on-click-modal="false", :show-close="false", class="custom-dialog")
      .custom-dialog-header
        span.el-dialog__title {{ modalTitle }}

      form(@submit.prevent="isAdding ? addUpf() : updateUpf()")
        div.form-row
          div.form-group
            label(class="label") Ano:    *
            input(
              v-model="newUpf.ano",
              :disabled="disableAnoInput",
              :style="{ cursor: disableAnoInput ? 'not-allowed' : 'auto' }",
              required,
              class="borda-input-ano"
            )

          div.form-group
            label(class="label") Ajuste Monetário (UPFPA):    *
            input(v-model="newUpf.valor", required, class="borda-input")

          div.form-group
            label(class="label") ifd 1:    *
            input(v-model="newUpf.ifd1", required, class="borda-input")

        div.form-row
          div.form-group
            label(class="label") ifd 2:    *
            input(v-model="newUpf.ifd2", required, class="borda-input")

          div.form-group
            label(class="label") Taxa Juros PF:    *
            input(v-model="newUpf.taxaJuros", required, class="borda-input")

          div.form-group
            label(class="label") Taxa Juros PJ:    *
            input(v-model="newUpf.taxaJurosPj", required, class="borda-input")
        div.custom-dialog-footer
            el-button(@click="buttonCancelar")
              span Cancelar
            el-button(
              v-if="isAdding", type="primary", @click="addUpf()", class='salvar')
              span Salvar
            el-button(
              v-else,
              type="primary",
              @click="buttonAlterar",
              :style="{ cursor: isCurrentYear(newUpf.ano) ? 'not-allowed' : 'pointer' }"
            )
              span Alterar
</template>

<script>
import { mapActions } from 'vuex'
import AppNotificacao from '@/components/mixins/AppNotificacao'

export default {
  mixins: [
    AppNotificacao],
  data () {
    return {
      disableAnoInput: true,
      upf: [],
      newUpf: {},
      editedUpf: null,
      isModalOpen: false,
      isAdding: true,
      modalTitle: 'Adicionar UPF'
    }
  },
  mounted () {
    this.getUpf()
    this.getNewUpf()
  },
  methods: {
    ...mapActions({
      getUpfPa: 'vtn/getUpf',
      addUpfPa: 'vtn/addUpf',
      updateUpfPa: 'vtn/updateUpfPa',
      getNewUpf: 'vtn/getNewUpf'
    }),
    async addUpf () {
      await this.addUpfPa(this.newUpf)
      this.getUpf()
      this.isModalOpen = false
    },
    async getUpf () {
      try {
        this.upf = await this.getUpfPa()
      } catch (error) {
        console.error('Erro ao buscar itens:', error)
      }
    },
    async updateUpf () {
      await this.updateUpfPa(this.newUpf)
      this.getUpf()
      this.resetNewUpf()
    },
    async editUpf (upf) {
      try {
        this.isCurrentYear()
        this.newUpf = {...upf}
        this.editedUpf = upf
        this.isModalOpen = true
        this.isAdding = false
        this.modalTitle = 'Editar UPF'
      } catch (error) {
        console.error('Erro ao editar Upf:', error)
      }
    },

    closeModal () {
      this.isModalOpen = false
      this.resetNewUpf()
    },
    async openModal (action) {
      this.newUpf = await this.getNewUpf()
      this.newUpf.ano = this.isYear()
      this.isModalOpen = true
      this.isAdding = action === 'add'
      this.modalTitle = action === 'add' ? 'Adicionar UPF' : 'Editar UPF'
    },

    buttonCancelar () {
      this.newUpf = {...this.editedUpf}
      this.isModalOpen = false
      this.resetNewUpf()
    },
    buttonSalvar () {
      this.addUpf()
      this.resetNewUpf()
      this.isModalOpen = false
    },
    buttonAlterar () {
      this.updateUpf()
      this.resetNewUpf()
      this.isModalOpen = false
    },
    resetNewUpf () {
      this.newUpf = {
        ano: this.isYear(),
        valor: '',
        ifd1: '0.0571',
        ifd2: '0.3129',
        taxaJuros: '0.04',
        taxaJurosPj: '0.0725'
      }
    },

    isCurrentYear (year) {
      const currentYear = new Date().getFullYear()
      return year !== currentYear
    },
    isYear () {
      const currentYear = new Date().getFullYear()
      return currentYear
    }

  }
}
</script>

<style scoped>
.el-dialog__body {
    padding: 0px 20px;
    color: #0000;
    font-size: 100px;
    border-radius: 10px !important;
}
.custom-dialog{
  border-radius: 20px;
}
.custom-dialog-header {
  display: flex;
  margin-top: -63px;
  margin-bottom: 50px;
  margin-left: -20px;
  margin-right: -20px;
  background-color: rgb(0, 143, 87);
  padding: 10px;
  text-align: left;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;

}
.el-dialog__body {
  padding: auto;
}
.el-dialog__title {
  color: #ffffff;
  font-size: 18px;
  display: flex;
  align-items: start;
}

.form-row {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.form-group {
  flex: 0 0 30%;
  margin-bottom: 30px;
}

.button-row {
  margin-top: 20px;
  text-align: right;
}

.button-row > * {
  margin-left: 10px;
}

.centralized {
  margin-top: 20px;
  width: 80%;
}

input {
  padding: 10px;
  margin: 10px;
  width: 100%;
}

.add-button {
  background-color: rgb(0, 143, 87);
  color: #fff;
  margin-top: 20px;
  padding: 15px;
}
.row-reverse {
  display: flex;
  flex-direction: row-reverse;
}
.custom-dialog-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.rounded-container {
  border-radius: 10px;
  border: 1px solid #ccc;
  width: 100%;
  padding: 25px;
}
.borda-input {
  border-radius: 8px;
  border: solid 1px rgb(185, 185, 185);
  outline: none;
  padding: 15px;
}
.borda-input-ano {
  border-radius: 8px;
  border: solid 1px rgb(185, 185, 185);
  outline: none;
  padding: 15px;
}

.borda-input:focus,
.borda-input:active {
  border: solid 1px rgb(0, 143, 87);
}

.label{
  margin-left: 12px;
}
.row {
  display: flex;
  flex-direction: row-reverse;
}
</style>



// WEBPACK FOOTER //
// src/screens/financeiro/upfpa/processoUpfpa.vue